import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Alert,
    CardBody,
    Button,
    Label,
    Input,
    FormFeedback,
    Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import UserService from "Api/Services/UserService";
import { useNavigate, useParams } from "react-router-dom";
import DrugService from "Api/Services/DrugService";
import Spinners from "components/Common/Spinner";

const DrugEdit = () => {

    //meta title
    document.title = "Drug Edit | Infuse One";
    const params = useParams();
    const imageUrl = `${process.env.REACT_APP_DRUG_IMAGE_API_URL}`;

    const navigate = useNavigate();
    const [status, setStatus] = useState(false);
    const [title, setDrugtitle] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [previewDataImage, setPreviewDataImage] = useState(null);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [drug, setDrug] = useState();
    const [isLoading, setLoading] = useState(false);
    const [errorimage, setErrorimage] = useState(false);



    const fetchDrugDetails = async () => {
        setLoading(true);
        try {
            const response = await DrugService.GetDrugById(params.id).json();
            if (response.status) {
                const drugData = response.data;
                setDrug(drugData);
                setDrugtitle(drugData.name);
                setStatus(drugData.status == 1 ? true : false);
                setPreviewDataImage(drugData.image ? imageUrl + '/' + drugData.image : null);
                setLoading(false);
            } else {
                setError('Failed to fetch drug details.');
            }
        } catch (error) {
            setError('Something went wrong while fetching drug details.');
        }
    };

    useEffect(() => {
        fetchDrugDetails();
    }, [params.id]);

    const handleStatusChange = () => {
        setStatus(!status);
    }

    // const handleImageChange = (e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         setPreviewImage(file);
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //             setPreviewImage(reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };
    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const fileType = file.type;
            const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

            if (validImageTypes.includes(fileType)) {
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviewImage(reader.result);
                };
                reader.readAsDataURL(file);
            } else {
                setErrorimage('Please upload a valid image.');
                return;
                // alert('Please upload a valid image file.');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const userData = {
            name: e.target.title.value,
            image: previewImage ? previewImage : null,
            form_iframe: e.target.form_iframe.value,
            status: status && status == true ? '1' : '0',
        };
        setLoading(true);
        try {
            const response = await DrugService.UpdateDrug(params.id, userData).json();
            if (response.status === true) {
                setSuccess(response.message);
                setLoading(false);
                setErrorimage('');
                navigate('/drug-list');
            } else {
                setLoading(false);
                setError(response.errors);
            }
        } catch (error) {
            setError('Something went wrong while updating the drug.');
        }
    };

    const handletitleChange = (e) => {
        const regex = /^[A-Za-z\s]*$/;
        const newValue = e.target.value;
        if (regex.test(newValue)) {
            setDrugtitle(newValue);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Drug Edit" />
                    {isLoading ? <Spinners setLoading={setLoading} /> :
                        <Card className="commonboxform">
                            <CardBody>
                                {success && (
                                    <Alert color="success" style={{ marginTop: "13px" }}>
                                        {success}
                                    </Alert>
                                )}

                                {/* <h4 className="card-title mb-4">Drug Edit</h4> */}
                                <Form onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <div className="mb-3">
                                            <Label className="form-label">Title <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name='title'
                                                value={title}
                                                onChange={handletitleChange}
                                            />
                                            {error.name && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>
                                                    {error.name[0]}
                                                </FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Image</Label>

                                            <div className="mb-3 text-left">
                                                <img
                                                    src={previewImage ? previewImage : previewDataImage}
                                                    alt="Profile Preview"
                                                    className="img-fluid"
                                                    style={{ width: '100px', height: '60px', objectFit: 'cover' }}
                                                />
                                            </div>
                                            <Input
                                                type="file"
                                                className="form-control"
                                                id="image"
                                                name='image'
                                                accept="image/*"
                                                onChange={handleImageChange}
                                            />
                                            {error.image && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.image}</FormFeedback>
                                            )}
                                            {errorimage && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{errorimage}</FormFeedback>
                                            )}

                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Iframe Form <i className="mdi mdi-asterisk text-danger asteriskiconsty"></i></Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="form_iframe"
                                                name='form_iframe'
                                                defaultValue={drug?.form_iframe}
                                            />
                                            {error.name && (
                                                <FormFeedback type="invalid" style={{ display: 'block' }}>{error.form_iframe}</FormFeedback>
                                            )}
                                        </div>
                                        <div className="mb-3">
                                            <Label className="form-label">Status</Label>
                                            <div className="form-check form-switch form-switch-lg mb-3" >
                                                <Input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id="customSwitchsizelg"
                                                    name='status'
                                                    checked={status}
                                                    onClick={handleStatusChange}
                                                />
                                                <Label
                                                    className="form-check-label"
                                                    htmlFor="customSwitchsizelg"
                                                >
                                                    {status && status == true ? 'Active' : 'Inactive'}
                                                </Label>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="text-left mt-4">
                                        <Button type="submit" color="secondary">
                                            Update
                                        </Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card>
                    }
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DrugEdit;
